export const getDateTime = (date, time) => {
  date.set("hour", time.hours());
  date.set("minute", time.minutes());
  date.set("second", time.seconds());
  return new Date(date).getTime();
};
